import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';

// Cosmetic gate only -- localStorage is writable by anyone with devtools, so
// this stops an idle player from wandering in, not an attacker. Authorisation
// is enforced server-side by adminController.middlewareAdminController, which
// admits a session only when users.role is something other than "user".
const ProtectedRoute = () => {
  const token = localStorage.getItem('admin');
  const role = (localStorage.getItem('role') || '').trim().toLowerCase();
  const isAdmin = Boolean(token) && role !== '' && role !== 'user';
  return isAdmin ? <Outlet /> : <Navigate to='/admin/login' />
}

export default ProtectedRoute
